export function isVerticalLineOnScreen(top: number, height: number): boolean {
  return top < window.innerHeight && top + height > 0
}
